/**
 * Configurazione fissa per build APK kiosk dedicati a una singola sede.
 * Impostare `sedeSlug` con il nome esatto della sede (campo `Nome` su backend)
 * PRIMA di lanciare la build APK per quel tablet — ogni tablet/sede richiede
 * la propria build con `sedeSlug` diverso.
 * Lasciare vuoto per la build web (prenotazione online, non kiosk).
 */
export const kioskConfig = {
    sedeSlug: 'Sportello Ufficio Verbali CMMI'
};
